import { ComponentProps } from 'react'
import { NavLink } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

interface ActiveLinkProps extends ComponentProps<typeof NavLink> {
  className?: string
}

export function ActiveLink({ to, className, ...rest }: ActiveLinkProps) {
  return (
    <NavLink
      to={to}
      className={twMerge(
        'text-sm font-normal uppercase text-bios-secondary 2xl:text-base',
        'transition-colors duration-300 hover:text-monochromatic-500 hover:underline',
        'aria-[current=page]:text-monochromatic-500 aria-[current=page]:underline',
        className,
      )}
      {...rest}
    />
  )
}
